var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashSaleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: "28px",
    viewBox: "0 0 158 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1123456968",
    filter: "url(#filter0_d_1313_862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SALE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.871 26.2295C101.85 26.2295 100.921 26.0311 100.087 25.6343C99.2522 25.2375 98.5471 24.7083 97.9715 24.047C97.3959 23.3709 96.9858 22.6287 96.7412 21.8203L98.2953 21.2251C98.6694 22.3421 99.2522 23.1945 100.044 23.7824C100.835 24.3556 101.778 24.6422 102.871 24.6422C103.562 24.6422 104.166 24.532 104.684 24.3115C105.217 24.0764 105.627 23.753 105.915 23.3415C106.202 22.93 106.346 22.4523 106.346 21.9085C106.346 21.1001 106.13 20.4755 105.699 20.0346C105.267 19.5937 104.648 19.2556 103.843 19.0205L100.95 18.1386C99.8134 17.8006 98.9356 17.2347 98.3169 16.4411C97.7125 15.6474 97.4103 14.7435 97.4103 13.7294C97.4103 12.8623 97.619 12.098 98.0363 11.4366C98.4536 10.7606 99.022 10.2315 99.7415 9.84932C100.475 9.46719 101.303 9.27612 102.224 9.27612C103.188 9.27612 104.051 9.45984 104.814 9.82727C105.591 10.18 106.246 10.6503 106.778 11.2382C107.31 11.8261 107.692 12.4801 107.922 13.2003L106.411 13.8176C106.066 12.8476 105.526 12.1127 104.792 11.613C104.073 11.1133 103.224 10.8634 102.245 10.8634C101.627 10.8634 101.08 10.9737 100.605 11.1941C100.144 11.4146 99.7846 11.7306 99.5256 12.1421C99.2666 12.5536 99.1371 13.0386 99.1371 13.5971C99.1371 14.2732 99.3457 14.8832 99.763 15.427C100.18 15.9561 100.821 16.3529 101.684 16.6175L104.231 17.3891C105.497 17.7712 106.454 18.3223 107.102 19.0425C107.749 19.7627 108.073 20.6666 108.073 21.7542C108.073 22.636 107.85 23.415 107.404 24.0911C106.972 24.7524 106.361 25.2742 105.569 25.6563C104.792 26.0385 103.893 26.2295 102.871 26.2295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.015 25.965L115.886 9.54067H117.743L123.614 25.965H121.8L120.419 21.9526H113.231L111.828 25.965H110.015ZM113.793 20.2991H119.815L116.555 10.8634H117.073L113.793 20.2991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.028 25.965V9.54067H127.754V24.3115H134.877V25.965H126.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.764 25.965V9.54067H148.125V11.1941H139.491V16.9041H147.693V18.5575H139.491V24.3115H148.125V25.965H137.764Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1123456967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "L",
    d: "M22.3071 25.7737V8.72217H25.3547V23.0272H32.5031V25.7737H22.3071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M34.9106 25.7737L40.6697 8.72217H44.6137L50.3727 25.7737H47.0562L45.8686 22.1116H39.4148L38.2047 25.7737H34.9106ZM40.2888 19.3651H44.9946L42.2159 10.8736H43.0675L40.2888 19.3651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H",
    d: "M71.325 25.7737V8.72217H74.3726V16.1608H81.4762V8.72217H84.5462V25.7737H81.4762V18.9073H74.3726V25.7737H71.325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F",
    d: "M9 25.7735V8.72192H20.1372V11.4685H12.0476V16.1834H19.1288V18.93H12.0476V25.7735H9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.9816 3.62821C56.0359 3.4468 56.1486 3.28754 56.3027 3.17429C56.4569 3.06104 56.6443 2.99989 56.8368 3H63.964C64.1051 3.00011 64.2441 3.03312 64.3697 3.09632C64.4952 3.15953 64.6037 3.25111 64.6862 3.36354C64.7686 3.47597 64.8227 3.60603 64.844 3.74301C64.8653 3.87999 64.8531 4.01997 64.8085 4.15143L61.637 13.4994H68.4184C68.5853 13.4993 68.7488 13.5452 68.8904 13.6318C69.0319 13.7185 69.1459 13.8425 69.2192 13.9897C69.2926 14.1368 69.3224 14.3013 69.3052 14.4643C69.2881 14.6272 69.2247 14.7822 69.1222 14.9115L56.6498 30.6606C56.522 30.8227 56.3403 30.9356 56.1364 30.9796C55.9325 31.0236 55.7194 30.9959 55.5342 30.9013C55.349 30.8067 55.2035 30.6513 55.1231 30.4621C55.0427 30.2729 55.0325 30.062 55.0943 29.8662L58.3033 19.624H52.3824C52.2439 19.6241 52.1073 19.5925 51.9834 19.5316C51.8595 19.4708 51.7518 19.3824 51.6687 19.2735C51.5857 19.1646 51.5297 19.0382 51.5051 18.9044C51.4805 18.7705 51.4881 18.6328 51.5271 18.5023L55.9816 3.62821Z",
    fill: "#FFBB57"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1313_862",
    x: 0,
    y: 0,
    width: 158,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1313_862"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1313_862",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashSaleLogo);
export default __webpack_public_path__ + "static/media/flash-sale-logo.6e62e8e382473f7a724f492f17f89084.svg";
export { ForwardRef as ReactComponent };